<script>
export default {
  props: {
    expanded: { type: Boolean, default: false },
    label: { type: String, required: true },
  },
}
</script>

<template>
  <details class="expandable-fields" :open="expanded">
    <summary class="label">{{ label }}…</summary>
    <slot></slot>
  </details>
</template>
